import { getExpressAPIHost } from '../../../../utils';
import axios from 'axios';

const REPORT_LABELS = {
    'delivery-report': 'Delivery Report',
    'coa-report': 'Certificate of Analysis',
    'bol-report': 'Bill of Lading',
    'loadout-coa-report': 'Loadout Certificate of Analysis',
};

const generateReport = async ({ resourceId, endPoint = 'route-sessions', report = 'delivery-report' }) => {
    try {
        if (!resourceId) throw new Error('Route session ID is required.');
        const response = await axios.put(`${getExpressAPIHost()}/${endPoint}/${report}/${resourceId}`);
        return response.data;
    } catch (err) {
        const message = err.response?.data?.message ?? err.message;
        throw new Error(`Unable to generate ${REPORT_LABELS[report] ?? report}: ${message}`);
    }
};

export default generateReport;
